(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('care-team-specialty', {
            parent: 'entity',
            url: '/care-team-specialty',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Care Team Specialties'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialties.html',
                    controller: 'CareTeamSpecialtyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('care-team-specialty-detail', {
            parent: 'entity',
            url: '/care-team-specialty/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'CareTeamSpecialty'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-detail.html',
                    controller: 'CareTeamSpecialtyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CareTeamSpecialty', function($stateParams, CareTeamSpecialty) {
                    return CareTeamSpecialty.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'care-team-specialty',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('care-team-specialty-detail.edit', {
            parent: 'care-team-specialty-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-dialog.html',
                    controller: 'CareTeamSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CareTeamSpecialty', function(CareTeamSpecialty) {
                            return CareTeamSpecialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('care-team-specialty.new', {
            parent: 'care-team-specialty',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-dialog.html',
                    controller: 'CareTeamSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('care-team-specialty', null, { reload: 'care-team-specialty' });
                }, function() {
                    $state.go('care-team-specialty');
                });
            }]
        })
        .state('care-team-specialty.edit', {
            parent: 'care-team-specialty',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-dialog.html',
                    controller: 'CareTeamSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CareTeamSpecialty', function(CareTeamSpecialty) {
                            return CareTeamSpecialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('care-team-specialty', null, { reload: 'care-team-specialty' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('care-team-specialty.delete', {
            parent: 'care-team-specialty',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-delete-dialog.html',
                    controller: 'CareTeamSpecialtyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CareTeamSpecialty', function(CareTeamSpecialty) {
                            return CareTeamSpecialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('care-team-specialty', null, { reload: 'care-team-specialty' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
